import Question, { QuestionsContainer, QuestionWrapper } from 'components/reports/Question'
import OutputDetails from 'components/reports/OutputDetails'
import ReferrableQuestionWrapper from 'components/reports/ReferrableQuestionWrapper'
import { formatDateMonthYear } from 'hooks/useDateUtils'

export default function CancerDetails({ data }) {

    var questions = data.conditionSpecific.questions

    return (
        <>
            <h3>Cancer Specific Questions</h3>

            <QuestionsContainer>

                <QuestionWrapper number='1'>
                    <Question>Please provide exact diagnosis to include date of diagnosis, type and site of tumour:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.exactDiagnosis.referToAttachments}>
                        <QuestionsContainer>
                            <QuestionWrapper number="a">
                                <Question answer={formatDateMonthYear(questions.exactDiagnosis.subQuestions.dateOfDiagnosis)}>Date of Diagnosis:</Question>
                            </QuestionWrapper>

                            <QuestionWrapper number="b">
                                <Question answer={questions.exactDiagnosis.subQuestions.typeOfTumour}>Type of Tumour:</Question>
                            </QuestionWrapper>

                            <QuestionWrapper number="c">
                                <Question answer={questions.exactDiagnosis.subQuestions.siteOfTumour}>Site of Tumour:</Question>
                            </QuestionWrapper>
                        </QuestionsContainer>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='2'>
                    <Question>Exact Staging/histology including Grading:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.exactStaging.referToAttachments}>
                        <p>{questions.exactStaging.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='3'>
                    <Question>Please provide the date and results of any investigations:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.investigations.referToAttachments}>
                        <OutputDetails
                            details={questions.investigations.details}
                        />
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='4'>
                    <Question>Please provide the name of the consultant and the date of last attendance:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.attendanceDetails.referToAttachments}>
                        <QuestionsContainer>
                            <QuestionWrapper number="a">
                                <Question answer={formatDateMonthYear(questions.attendanceDetails.subQuestions.dateOfLastAttendance)}>Date of Last Attendance:</Question>
                            </QuestionWrapper>
                            <QuestionWrapper number="b">
                                <Question answer={questions.attendanceDetails.subQuestions.consultantName}>Name of Consultant:</Question>
                            </QuestionWrapper>
                        </QuestionsContainer>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='5'>
                    <Question>Please confirm date(s) and result(s) of last follow up(s):</Question>
                    <ReferrableQuestionWrapper isReferred={questions.followUps.referToAttachments}>
                        <OutputDetails
                            details={questions.followUps.details}
                        />
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='6'>
                    <Question>Details of Treatment:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.detailsOfTreatment.referToAttachments}>
                        <p>{questions.detailsOfTreatment.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='7'>
                    <Question>Date treatment finished:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.dateTreatmentFinished.referToAttachments}>
                        <p>{formatDateMonthYear(questions.dateTreatmentFinished.value)}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='8'>
                    <Question>Has there been any evidence of recurrence or spread?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.evidenceOfRecurrence.referToAttachments}>
                        <p>{questions.evidenceOfRecurrence.value}</p>
                        {questions.evidenceOfRecurrence.value === 'Yes' && (
                            <>
                                <Question>If yes please provide full details, including dates</Question>
                                <OutputDetails
                                    details={questions.evidenceOfRecurrence.details}
                                />
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='9'>
                    <Question>Are there any other factors or co-morbidities present which may influence the prognosis of this condition?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyOtherFactors.referToAttachments}>
                        <p>{questions.anyOtherFactors.value}</p>

                        <Question
                            show={questions.anyOtherFactors.value === 'Yes'}
                            answer={questions.anyOtherFactors.details}
                        >
                            If yes, please provide details
                        </Question>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

            </QuestionsContainer>
        </>
    )
}